import { FC, ReactElement } from 'react';
import styles from './styles.module.scss';

export interface Props {
  number: number;
  title: ReactElement;
  subtitle: ReactElement;
}

export const BenefitItem: FC<Props> = ({ number, title, subtitle }) => {
  return (
    <div className={styles.item}>
      <div className={styles.titleWrapper}>
        <span className={styles.number}>{number}</span>
        <span className={styles.title}>{title}</span>
      </div>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
};
